const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

class UTMService {
	private _utmParams: Record<string, string> = {};

	storeUTMParams() {
		this._utmParams = {
			...this._utmParams,
			...this.parseUTMParams(),
		};
	}

	parseUTMParams() {
		const params = new URLSearchParams(window.location.search);
		const utmParams: Record<string, string> = {};

		utmKeys.forEach((key) => {
			const value = params.get(key);
			if (value) {
				utmParams[key] = value;
			}
		});

		return utmParams;
	}

	get utmParams() {
		return this._utmParams;
	}
}

const utmService = new UTMService();
export default utmService;
